import { render, staticRenderFns } from "./IamImpersonation.vue?vue&type=template&id=22c2e5fe&scoped=true&"
import script from "./IamImpersonation.vue?vue&type=script&lang=ts&"
export * from "./IamImpersonation.vue?vue&type=script&lang=ts&"
import style0 from "./IamImpersonation.vue?vue&type=style&index=0&id=22c2e5fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c2e5fe",
  null
  
)

export default component.exports